import Popin from './popin';

export default informationPopin => {
  const dataPopin = informationPopin.getAttribute('data-popin');
  const popin = document.querySelector(`#${dataPopin}`);
  const popinCookieValue = popin.getAttribute('data-cname');
  const cookieInfoName = "golf_info_popin";

  function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }

  function hasAcceptCookies() {
    let cookieinfos_json = localStorage.getItem('rgpd');
    if (cookieinfos_json != "") {
      let cookieinfos = JSON.parse(localStorage.getItem('rgpd'));
      if (cookieinfos && typeof cookieinfos.statistiques !== 'undefined' && cookieinfos.statistiques === true) {
        return true;
      }
      return false;
    }
  }

  function loadPopin() {
    if (hasAcceptCookies()) {
      let cookie_value = getCookie(cookieInfoName);
      if (cookie_value != popinCookieValue) {
        setCookie(cookieInfoName, popinCookieValue, 1);
        Popin({
          id: dataPopin,
          closeOutsiteAction: false,
          beforeOpen() {
          },
          afterClose() {
          },
        });
      }
    }
  }
  setTimeout(function () {
    loadPopin();
  }, 50);



  document.addEventListener('rgpd-consent', function (event) {
    loadPopin();
  });


};
